import { render, staticRenderFns } from "./CSidebarMenu.vue?vue&type=template&id=032fbaa8"
import script from "./CSidebarMenu.vue?vue&type=script&lang=js"
export * from "./CSidebarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032fbaa8')) {
      api.createRecord('032fbaa8', component.options)
    } else {
      api.reload('032fbaa8', component.options)
    }
    module.hot.accept("./CSidebarMenu.vue?vue&type=template&id=032fbaa8", function () {
      api.rerender('032fbaa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CSidebarMenu.vue"
export default component.exports